module.exports = "/static/assets/3bf6b664e3628a62c4bc3f6a67b5c2b6.png";